module.exports = __webpack_public_path__ + "static/media/doordash.06f60781.png";